module.exports = __webpack_public_path__ + "img/36_33.e47deb93.png";